export default __webpack_public_path__ + "static/MobileSizzle_V6 - Approved-026a60e671c05a4eca7743e7fdf5ecd8.webm";